import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';

declare var $: any;
declare var jQuery: any;
declare var defaultGridEditSettings;

@Component({
  selector: 'fx-brokers',
  templateUrl: 'fx-brokers.component.html',
  styleUrls: ['fx-brokers.component.css'],
})

export class FXBrokersBranch{

  constructor (private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit(){

    //Set the page title
    this.titleService.setTitle("WiseRisk | FX Broker Settings");

    /*<![CDATA[*/
    		var mainNav = "setting-nav";
    		var sideNav = "side-nav-setting-fx-broker";

            $(document).ready(function() {
                // prepare the data
    			var data = [ {
    				"brokerCode" : "JPM",
    				"brokerDisplayName" : "JP Morgan"
    			}, {
    				"brokerCode" : "CS",
    				"brokerDisplayName" : "Credit Suisse"
    			}, {
    				"brokerCode" : "HSBC",
    				"brokerDisplayName" : "HSBC"
    			} ];

                var source = {
                    localdata: data,
                    datafields:
                    [
                        { name: 'brokerCode', type: 'string' },
                        { name: 'brokerDisplayName', type: 'string' }
                    ]
                };
    			var settings = defaultGridEditSettings("#jqxgrid", source);
    			settings.columns = [ {
    				text : 'Broker Code',
    				columntype : 'textbox',
    				datafield : 'brokerCode',
    				width : '25%'
    			}, {
    				text : 'Display Name',
    				columntype : 'textbox',
    				datafield : 'brokerDisplayName',
    				width : '40%'
    			} ];
    			$("#jqxgrid").jqxGrid(settings);
            });
       	/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/fx-brokers/fx-brokers.component.ts